import { useContext, useEffect } from "react";
import GenericFlyout from "../modal/GenericFlyout";
import { useBjelinTranslations } from "../../hooks/TranslationHooks";
import { Badge } from "reactstrap";
import {
  filterProductsBySkus,
  filterValidSkus,
  getRankedAccessories
} from "../../utils/ProductsUtils";
import { useUserProducts } from "../../hooks/ProductHooks";
import { CartContext } from "../../functional-components/CartContext";
import CockpitProductGrid from "../CockpitLayoutComponents/CockpitProductGrid";
import BjelinButton from "../BjelinButton";
import Cart from "../Cart";
import CartTotal from "../CartTotal";
import { b2bCheckoutUrl, checkoutUrl, shopUrl } from "../../config/urls";
import { useCurrentUser } from "../../functional-components/UserContext";
import COLORS from "../../config/colors";
import Icon from "../Icon";
import { motion } from "motion/react";
import { useLocation } from "react-router-dom";
import "./cart-dropdown.scss";

const CartDropdown = () => {
  const location = useLocation();
  const t = useBjelinTranslations();
  const { b2b } = useCurrentUser();
  const products = useUserProducts();
  const {
    hasItems,
    itemCount,
    getCartIsOpen,
    closeCartDropdown,
    toggleCartDropdown,
    refreshData
  } = useContext(CartContext);
  const showCart = getCartIsOpen();

  useEffect(() => {
    refreshData(products);
  }, [refreshData, products]);

  useEffect(() => {
    if (location.key) {
      closeCartDropdown();
    }
  }, [closeCartDropdown, location.key]);

  return (
    <>
      <motion.button
        id="cart-menu-button"
        title={t("menu.tooltip.cart")}
        aria-haspopup="dialog"
        className="nav-link"
        style={{
          backgroundColor: showCart ? "#fff" : "transparent",
          border: 0,
          paddingRight: 20
        }}
        aria-expanded={showCart}
        onClick={toggleCartDropdown}
        initial={{
          scale: 0.5
        }}
        animate={{
          scale: 1
        }}
        transition={{ type: "spring", stiffness: 500 }}
      >
        <Icon name="cart-shopping" className="icon" />
        {hasItems() && (
          <Badge color="bjelin-orange" style={{ color: "#000" }} pill>
            {itemCount()}
          </Badge>
        )}
      </motion.button>
      <GenericFlyout
        id="cart-dropdown"
        isOpen={showCart}
        close={closeCartDropdown}
        noCloseBtn
        align={"top"}
        ariaLabel={t("cart.heading")}
      >
        {hasItems() ? (
          <div className="cart-dropdown-content">
            <div className={"h3 p-3 m-0"}>{t("cart.heading")}</div>
            <div
              style={{
                flex: "1 1 100%",
                display: "flex",
                flexDirection: "column",
                overflowY: "auto",
                overflowX: "hidden"
              }}
            >
              <div>
                <Cart isCompact={true} />
              </div>
              <CartTotal style={{ padding: "0 15px" }} />
            </div>
            <div
              style={{
                height: "4rem",
                minHeight: "4rem",
                display: "flex"
              }}
            >
              <BjelinButton
                id={"cart-dropdown-to-shop"}
                style={{
                  borderRadius: 0,
                  flex: "0 0 40%",
                  padding: "0.5rem 2rem"
                }}
                color={"bjelin-grey"}
                url={shopUrl}
              >
                {t("to.shop")}
              </BjelinButton>
              <BjelinButton
                id={"cart-dropdown-order"}
                style={{
                  borderRadius: 0,
                  flex: "1 1 100%",
                  padding: "0.5rem 2rem"
                }}
                color={"primary"}
                url={b2b ? b2bCheckoutUrl : checkoutUrl}
                icon={"arrow-right"}
              >
                {t(b2b ? "check.out.b2b" : "check.out")}
              </BjelinButton>
            </div>
          </div>
        ) : (
          <div
            className={"px-4 py-3"}
            style={{
              background: "#fff"
            }}
          >
            <h2>{t("cart.isempty")}</h2>
            <BjelinButton color={"primary"} url={shopUrl}>
              {t("to.shop")}
            </BjelinButton>
          </div>
        )}
      </GenericFlyout>
    </>
  );
};

export default CartDropdown;
